<ng-container *ngIf="(features$ | async) && itemSelectionFormGroup">
	<mat-vertical-stepper
		[linear]="true"
		#stepper
		(selectionChange)="handleSelectionChange($event)">
		<mat-step
			[stepControl]="itemSelectionFormGroup"
			[completed]="itemSelectionFormGroup.valid"
			[editable]="(complete$ | async) !== true">
			<ng-template matStepLabel>
				<cm-localize
					[name]="locs.SPCreqUploadStepOneTitle"
					[cpName]="locs.CPCreqUploadStepOneTitle" />
			</ng-template>
			<div [formGroup]="itemSelectionFormGroup">
				<cm-selection-form [features$]="features$" (next)="handleNext(stepper)" [hasAdvancedFeature]="hasAdvancedFeature$ | async">
				</cm-selection-form>
			</div>
		</mat-step>

		<mat-step
			[stepControl]="itemUploadFormGroup"
			[completed]="itemUploadFormGroup.valid"
			[editable]="(complete$ | async) !== true">
			<div class="upload-step__content">
				<div class="upload-step__selections">
					<cm-selection-list></cm-selection-list>
				</div>
				<div class="upload-step__view">
					<ng-template matStepLabel>
						<cm-localize
							[name]="locs.SPCreqUploadStepTwoTitle"
							[cpName]="locs.CPCreqUploadStepTwoTitle" />
					</ng-template>
					<ng-container *ngIf="stepper.selectedIndex === 1">
						<div [formGroup]="itemUploadFormGroup">
							<cm-upload-form [cmcId$]="cmcId$" (next)="handleCompletion(stepper)">
							</cm-upload-form>
						</div>
					</ng-container>
				</div>
			</div>
		</mat-step>

		<mat-step [completed]="false">
			<ng-template matStepLabel>
				<cm-localize
					[name]="locs.SPCreqUploadStepThreeTitle"
					[cpName]="locs.CPCreqUploadStepThreeTitle" />
			</ng-template>
			<div class="upload-step__content">
				<div class="upload-step__selections">
					<cm-selection-list></cm-selection-list>
				</div>
				<div class="upload-step__view">
					<cm-upload-confirmation (restart)="handleRestart(stepper)">
					</cm-upload-confirmation>
				</div>
			</div>
		</mat-step>
		<ng-template matStepperIcon="edit">
			<span class="step-icon">
				<ats-icon name="pencil"></ats-icon>
			</span>
		</ng-template>
		<ng-template matStepperIcon="done">
			<span class="step-icon">
				<ats-icon name="check"></ats-icon>
			</span>
		</ng-template>
		<ng-template matStepperIcon="error">
			<span class="step-icon">
				<ats-icon name="warning"></ats-icon>
			</span>
		</ng-template>
	</mat-vertical-stepper>
</ng-container>
